export default __webpack_public_path__ + "static/media/logo.4e1e8696.png";